import { CLASSNAMES, DESKTOP_BREAKPOINT, ELEMENTS } from './lib';

const navIsOnHighlight = () => ELEMENTS.nav().classList.contains(CLASSNAMES.navOnHighlight);

const setHighlightColorScheme = () => {
	ELEMENTS.nav().setAttribute('data-color-scheme', 'highlight');
};

const removeHighlightColorScheme = () => {
	ELEMENTS.nav().hasAttribute('data-color-scheme') && ELEMENTS.nav().removeAttribute('data-color-scheme');
};

export const setNavColorScheme = () => {
	// Adds a class to differ between nav and background
	if (window.scrollY > 0 || ELEMENTS.openSubMenuListItem() || window.innerWidth < DESKTOP_BREAKPOINT) {
		ELEMENTS.nav().classList.add(CLASSNAMES.navBg);
		removeHighlightColorScheme();
	} else {
		ELEMENTS.nav().classList.remove(CLASSNAMES.navBg);
		if (navIsOnHighlight()) {
			setHighlightColorScheme();
		}
	}
};
